import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserRoleInterface } from '../../model/user/user-role-interface';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OrganisationInterface } from '../../model/organisations/organisation-interface';
import { UserInterface } from '../../model/user/user-interface';
import { UserService } from '../user-service/userservice';
import { UserRoleDatasourceInterface } from '../../model/user/user-role-datasource-interface';
import { UnconfirmedUserPageInterface } from 'src/app/model/user/unconfirmed-user-page-interface';
import { DialogService } from '../dialog-service/dialog-service.service';

const SWARM_API = '/proxy/api/v0/userservice';
const USER_PREFIX = '/users';
const ACCOUNT_PREFIX = '/accounts';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable({
    providedIn: 'root'
})
export class NutzerverwaltungService {
    constructor(
        private http: HttpClient,
        private userService: UserService,
        private dialogService: DialogService
    ) {}

    updateUserRole(
        userId: number,
        userRole: String,
        success: Function,
        error: Function
    ): void {
        this.http
            .put<UserRoleInterface>(
                SWARM_API + USER_PREFIX + '/' + userId + '/role',
                userRole
            )
            .subscribe(
                (user) => {
                    success();
                },
                () => {
                    error();
                }
            );
    }

    changeComposerAccessOfUser(
        userId: number,
        composerAccess: boolean,
        success: Function,
        error: Function
    ): void {
        this.http
            .put<UserRoleInterface>(
                SWARM_API + USER_PREFIX + '/' + userId + '/composerAccess',
                composerAccess
            )
            .subscribe(
                (user) => {
                    success();
                },
                () => {
                    error();
                }
            );
    }

    addUserToOrganisation(
        organisation: OrganisationInterface,
        userId: number,
        success: Function,
        error: Function
    ): void {
        if (!this.userService.isCurrentUserPlatformAdmin()) {
            return;
        } else {
            const json = JSON.stringify(organisation);

            this.http
                .post<UserInterface>(
                    SWARM_API + USER_PREFIX + '/memberships/' + userId,
                    json,
                    httpOptions
                )
                .subscribe(
                    (data) => {
                        success();
                    },
                    () => {
                        error();
                    }
                );
        }
    }

    getUsersWithRolesSlice(
        pageIndex: number,
        pageSize: number,
        searchString: string
    ): Observable<UserRoleDatasourceInterface> {
        const dto = {
            pageIndex: pageIndex,
            pageSize: pageSize,
            searchString: searchString
        };
        const json = JSON.stringify(dto);
        return this.http.post<UserRoleDatasourceInterface>(
            SWARM_API + USER_PREFIX + '/roles',
            json,
            httpOptions
        );
    }

    public getUnconfirmedUserSlice(
        pageIndex: number,
        pageSize: number,
        searchString: string
    ): Observable<UnconfirmedUserPageInterface> {
        return this.http.put<UnconfirmedUserPageInterface>(
            SWARM_API + USER_PREFIX + '/unconfirmed',
            {
                pageIndex: pageIndex,
                pageSize: pageSize,
                searchString: searchString
            },
            httpOptions
        );
    }

    public confirmUserRegistration(userId: number): Observable<void> {
        return this.http
            .put<void>(
                SWARM_API + USER_PREFIX + `/confirmation/${userId}`,
                {},
                httpOptions
            )
            .pipe(
                tap(() =>
                    this.dialogService.openDialog(
                        'Nutzer bestätigt',
                        'Der Nutzer wurde erfolgreich bestätigt'
                    )
                )
            );
    }

    public deleteUser(userId: number): Observable<UserInterface> {
        return this.http
            .post<UserInterface>(
                `${SWARM_API}${ACCOUNT_PREFIX}/deleteUserAsPA/${userId}`,
                httpOptions
            )
            .pipe(
                tap(() =>
                    this.dialogService.openDialog(
                        'Nutzer gelöscht',
                        'Das Konto wurde erfolgreich gelöscht'
                    )
                )
            );
    }

    public openConfirmDeleteMemberDialog(): Observable<boolean> {
        return this.dialogService.openConfirmDialog(
            'Wollen Sie die Mitgliedschaft wirklich entfernen?',
            'Abbrechen',
            'Entfernen'
        );
    }

    public openConfirmMemberDialog(): Observable<boolean> {
        return this.dialogService.openConfirmDialog(
            'Wollen Sie den Nutzer wirklich bestätigen?',
            'Abbrechen',
            'Bestätigen'
        );
    }
}
